import City from './City.class'
import Region from './Region.class'
import Simple from './SimpleName/Simple.class'
import get from 'lodash/get'

export default class AddressCrud {
	constructor (init = {}) {
		this.id = get(init, 'id', null)
		this.city = get(init, 'city') ? new City(init.city) : new City()
		this.region = get(init, 'region') ? new Region(init.region) : new Region()
		this.country = get(init, 'country') ? init.country : new Simple()
		this.post_code = get(init, 'post_code', null)
		this.street = get(init, 'street', '')
		this.house = get(init, 'house', '')
		this.building = get(init, 'building', '')
		this.wing = get(init, 'wing', '')
		this.apartament = get(init, 'apartament', '')
		this.place = get(init, 'place', '')
		this.geo_point = get(init, 'geo_point', '')
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Address.class.js